import React from 'react';
import { Link } from 'react-router-dom';
import core from '@gin-betting/core';

import { Icon } from 'components';

import arrowRight from 'assets/svg/arrow-left.svg';
import './tournamentItemWrapper.scss';

interface Props {
    tournamentId?: string;
    onClick: VoidFn;
    children: JSX.Element[] | JSX.Element;
}

const {
    utils: { getFiltersFromLocation },
    services: { stringify },
} = core;

const TournamentItemWrapper: React.FC<Props> = ({
    children,
    tournamentId,
    onClick,
}) => {
    const content = (
        <React.Fragment>
            {children}

            <Icon styleName="arrow-icon" glyph={arrowRight} />
        </React.Fragment>
    );

    if (!tournamentId) {
        return (
            <div onClick={onClick} styleName="container">
                {content}
            </div>
        );
    }

    return (
        <Link
            styleName="container"
            to={{
                search: getLinkToTournament(tournamentId),
            }}
            onClick={onClick}
        >
            {content}
        </Link>
    );
};

function getLinkToTournament(tournamentId: string): string {
    const filters = getFiltersFromLocation();

    return stringify({
        ...filters,
        tournamentIds: undefined,
        tournamentId,
    });
}

export default React.memo(TournamentItemWrapper);
